import { createRouter, createRoute, createRootRoute, RouterProvider, Outlet } from "@tanstack/react-router";
import LandingPage from "./routes/index";
import { AppPage } from "./routes/app";
import { AuthPage } from "./routes/auth";
import { ParentsPage } from "./routes/parents";
import { SchoolsPage } from "./routes/schools";
import { MerchantsPage } from "./routes/merchants";
import { AboutPage } from "./routes/about";
import DemoPage from "./routes/demo";
import { ExperiencePage } from "./routes/experience";
import { IntelligencePage } from "./routes/intelligence";
import { AnalyticsPage } from "./routes/analytics";
import { TransportPage } from "./routes/transport";
import { CatchmentsPage } from "./routes/catchments";
import { MessagingCentrePage } from "./routes/messages";
import WhyFundredPage from "./routes/why-fundred";
import FiveWeeksPage from "./routes/five-weeks";
import { ProductDetailPage } from "./components/landing/product-detail-page";
import { SiteSeo } from "./components/site-seo";

const rootRoute = createRootRoute({
  component: () => (
    <>
      <SiteSeo />
      <Outlet />
    </>
  ),
});

const indexRoute = createRoute({ getParentRoute: () => rootRoute, path: "/", component: LandingPage });
const appRoute = createRoute({ getParentRoute: () => rootRoute, path: "/app", component: AppPage });
const authRoute = createRoute({ getParentRoute: () => rootRoute, path: "/auth", component: AuthPage });
const parentsRoute = createRoute({ getParentRoute: () => rootRoute, path: "/parents", component: ParentsPage });
const schoolsRoute = createRoute({ getParentRoute: () => rootRoute, path: "/schools", component: SchoolsPage });
const merchantsRoute = createRoute({ getParentRoute: () => rootRoute, path: "/merchants", component: MerchantsPage });
const aboutRoute = createRoute({ getParentRoute: () => rootRoute, path: "/about", component: AboutPage });
const demoRoute = createRoute({ getParentRoute: () => rootRoute, path: "/demo", component: DemoPage });
const productDetailRoute = createRoute({ getParentRoute: () => rootRoute, path: "/ecosystem/$productId", component: ProductDetailPage });
const experienceRoute = createRoute({ getParentRoute: () => rootRoute, path: "/experience", component: ExperiencePage });
const intelligenceRoute = createRoute({ getParentRoute: () => rootRoute, path: "/intelligence", component: IntelligencePage });
const analyticsRoute = createRoute({ getParentRoute: () => rootRoute, path: "/analytics", component: AnalyticsPage });
const transportRoute = createRoute({ getParentRoute: () => rootRoute, path: "/transport", component: TransportPage });
const catchmentsRoute = createRoute({ getParentRoute: () => rootRoute, path: "/catchments", component: CatchmentsPage });
const messagesRoute = createRoute({ getParentRoute: () => rootRoute, path: "/messages", component: MessagingCentrePage });
const whyFundredRoute = createRoute({ getParentRoute: () => rootRoute, path: "/why-fundred", component: WhyFundredPage });
const fiveWeeksRoute = createRoute({ getParentRoute: () => rootRoute, path: "/five-weeks", component: FiveWeeksPage });

const routeTree = rootRoute.addChildren([
  indexRoute,
  appRoute,
  authRoute,
  parentsRoute,
  schoolsRoute,
  merchantsRoute,
  aboutRoute,
  demoRoute,
  productDetailRoute,
  experienceRoute,
  intelligenceRoute,
  analyticsRoute,
  transportRoute,
  catchmentsRoute,
  messagesRoute,
  whyFundredRoute,
  fiveWeeksRoute,
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export function AppRouter() {
  return <RouterProvider router={router} />;
}
